<template>
  <div 
    id="modal-outer" 
    :style="outerWrapperStyles"
    @click="hideModal">
    <div 
      :style="innerWrapperStyles"
      @click.stop.prevent="">
      <h1>{{title}}</h1>
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ModalBackground',
  props: {
    msg: String,
    title:{
      type:String,
      default:""
    },
    outerWrapperStyles:{
      type:Object,
      default:function(){return {}}
    },
    innerWrapperStyles:{
      type:Object,
      default:function(){return {}}
    }
  },
  data:function(){
    return {

    }
  },
  created(){

  },
  mounted(){

  },
  methods:{
    hideModal(){
      this.$emit('deactivateModal');
    }
  }
}
</script>

<style scoped>

#modal-outer {
  position:absolute;
  transition: all 0.5s ease;
  height:100vh;
  width:100%;
  background:#ffffff;
}
.flex {
  display:flex;
}
</style>
